export default __webpack_public_path__ + "static/organic-textile_gots-80c1e6d7d3678af659f0c7a9f3dca978.jpeg";